import { combineReducers } from "redux"
import { planningBlocks } from "./planningBlocksReducer"

const planningBlocksReducer = combineReducers({
    planningBlocks
})

export default planningBlocksReducer

